import React from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'app/components/misc/ErrorPage';
import Page from 'app/components/misc/BasePage';
import PageHead from 'app/components/misc/PageHead';
import FAQContent from 'app/pageContents/FAQContent';
import prismicApi from 'app/api/prismicApi';
import { PAGE_TYPE } from 'app/constants/app';
import { configureStaticPageHead } from 'app/utils/configurePageHead';
import get from 'lodash/get';

const propTypes = {
  doc: PropTypes.object,
};

const FAQ = ({ doc }) => {
  if (!doc) return <ErrorPage />;

  if (doc) {
    return (
      <Page withBackground>
        <PageHead {...configureStaticPageHead(PAGE_TYPE.FAQ)} />
        <FAQContent doc={doc} />
      </Page>
    );
  }
};

FAQ.getInitialProps = async ({ res }) => {
  const response = await prismicApi('document.type', 'faq');
  const doc = get(response, 'results[0].data.qna');
  if (res && !doc) res.statusCode = 404;
  return { doc };
};

FAQ.propTypes = propTypes;

export default FAQ;
